<?xml version="1.0" encoding="UTF-8"?>
<svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>Form Elements/Checkbox/x/partly_select/12</title>
    <desc>Created with Sketch.</desc>
    <g id="Form-Elements/Checkbox/x/partly_select/12" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <polygon id="Path-4" fill="#FFFFFF" fill-rule="nonzero" points="9 5 9 7 3 7 3 5"></polygon>
    </g>
</svg>